import styled from 'styled-components';

import { mediaConfined } from '@xing-com/layout-tokens';

import {
  CONTAINER_EXPANDED,
  CONTAINER_NARROW,
  CONTAINER_REGULAR,
  CONTAINER_WIDE,
} from './constants';

export type ContainerVariant = 'narrow' | 'regular' | 'wide' | 'expanded';

const widths = {
  narrow: `${CONTAINER_NARROW}px`,
  regular: `${CONTAINER_REGULAR}px`,
  wide: `${CONTAINER_WIDE}px`,
  expanded: `${CONTAINER_EXPANDED}px`,
};

/**
 * A component to limit the width of the content and center it.
 *
 * If you use this together with a `<Section>` it should be inside the section:
 * ```tsx
 * <Section>
 *   <Container>...</Container>
 * </Section>
 * ```
 */
export const Container = styled.div<{ variant?: ContainerVariant }>`
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  max-width: ${({ variant }) => {
    switch (variant) {
      case 'narrow':
        return widths.narrow;
      case 'wide':
        return widths.wide;
      case 'expanded':
        return widths.expanded;
      default:
        return widths.regular;
    }
  }};
  @media ${mediaConfined} {
    padding-inline: 0;
  }
`;
